import { AgsInitState } from "ags/state-machine/states/ags-init-state";

export class ThemeInit extends AgsInitState {
    public onExit() {

    }
}
